
import { WorldCountry } from '../types';

// Fase 12 - Expansión América: Países del Caribe y Centroamérica expandidos
export const americaExpansion6: WorldCountry[] = [
  // Jamaica expandida (Fase 12)
  {
    name: 'Jamaica',
    slug: 'jamaica',
    code: 'JM',
    population: 2961167,
    topCities: [
      { name: 'Kingston', slug: 'kingston', population: 584627 },
      { name: 'Spanish Town', slug: 'spanish-town', population: 147152 },
      { name: 'Portmore', slug: 'portmore', population: 182153 },
      { name: 'Montego Bay', slug: 'montego-bay', population: 110115 },
      { name: 'May Pen', slug: 'may-pen', population: 61548 },
      { name: 'Mandeville', slug: 'mandeville', population: 49695 },
      { name: 'Old Harbour', slug: 'old-harbour', population: 28912 },
      { name: 'Savanna-la-Mar', slug: 'savanna-la-mar', population: 22633 },
      { name: 'Ocho Rios', slug: 'ocho-rios', population: 16671 },
      { name: 'Linstead', slug: 'linstead', population: 21744 },
      { name: 'Half Way Tree', slug: 'half-way-tree', population: 95943 },
      { name: 'Port Antonio', slug: 'port-antonio', population: 13246 },
      { name: 'Morant Bay', slug: 'morant-bay', population: 9892 },
      { name: 'Lucea', slug: 'lucea', population: 6000 },
      { name: 'Falmouth', slug: 'falmouth', population: 8239 },
      { name: 'Black River', slug: 'black-river', population: 4000 },
      { name: 'Port Maria', slug: 'port-maria', population: 7500 },
      { name: 'Annotto Bay', slug: 'annotto-bay', population: 3000 },
      { name: 'Bog Walk', slug: 'bog-walk', population: 8500 },
      { name: 'Chapelton', slug: 'chapelton', population: 2500 },
      { name: 'Constant Spring', slug: 'constant-spring', population: 52000 },
      { name: 'New Kingston', slug: 'new-kingston', population: 67000 },
      { name: 'Cross Roads', slug: 'cross-roads', population: 35000 },
      { name: 'Papine', slug: 'papine', population: 42000 },
      { name: 'Liguanea', slug: 'liguanea', population: 38000 },
      { name: 'Meadowbrook', slug: 'meadowbrook', population: 28000 },
      { name: 'Barbican', slug: 'barbican', population: 32000 },
      { name: 'Mona', slug: 'mona', population: 25000 },
      { name: 'Hope Pastures', slug: 'hope-pastures', population: 22000 },
      { name: 'Red Hills', slug: 'red-hills', population: 30000 },
      { name: 'Stony Hill', slug: 'stony-hill', population: 18000 },
      { name: 'Irish Town', slug: 'irish-town', population: 5000 },
      { name: 'Gordon Town', slug: 'gordon-town', population: 7000 },
      { name: 'Mavis Bank', slug: 'mavis-bank', population: 3500 },
      { name: 'Blue Mountain Peak', slug: 'blue-mountain-peak', population: 500 }
    ]
  },
  // Trinidad y Tobago (Fase 12)
  {
    name: 'Trinidad and Tobago',
    slug: 'trinidad-and-tobago',
    code: 'TT',
    population: 1399488,
    topCities: [
      { name: 'Port of Spain', slug: 'port-of-spain', population: 37074 },
      { name: 'San Fernando', slug: 'san-fernando', population: 48838 },
      { name: 'Chaguanas', slug: 'chaguanas', population: 83516 },
      { name: 'Arima', slug: 'arima', population: 33606 },
      { name: 'Point Fortin', slug: 'point-fortin', population: 20235 },
      { name: 'Scarborough', slug: 'scarborough', population: 17000 },
      { name: 'Diego Martin', slug: 'diego-martin', population: 105000 },
      { name: 'Penal', slug: 'penal', population: 12281 },
      { name: 'Siparia', slug: 'siparia', population: 14312 },
      { name: 'Tunapuna', slug: 'tunapuna', population: 22741 },
      { name: 'Piarco', slug: 'piarco', population: 4757 },
      { name: 'St. Augustine', slug: 'st-augustine', population: 35547 },
      { name: 'Curepe', slug: 'curepe', population: 18000 },
      { name: 'Tacarigua', slug: 'tacarigua', population: 12000 },
      { name: 'Trincity', slug: 'trincity', population: 25000 },
      { name: 'Maraval', slug: 'maraval', population: 28000 },
      { name: 'Westmoorings', slug: 'westmoorings', population: 12000 },
      { name: 'St. James', slug: 'st-james', population: 24000 },
      { name: 'Woodbrook', slug: 'woodbrook', population: 18000 },
      { name: 'Newtown', slug: 'newtown', population: 15000 },
      { name: 'Belmont', slug: 'belmont', population: 16000 },
      { name: 'Laventille', slug: 'laventille', population: 35000 },
      { name: 'Morvant', slug: 'morvant', population: 42000 },
      { name: 'Barataria', slug: 'barataria', population: 28000 },
      { name: 'San Juan', slug: 'san-juan', population: 54900 },
      { name: 'Arouca', slug: 'arouca', population: 22000 },
      { name: 'Maloney', slug: 'maloney', population: 18000 },
      { name: 'D\'Abadie', slug: 'dabadie', population: 8000 },
      { name: 'Cumuto', slug: 'cumuto', population: 3500 },
      { name: 'Valencia', slug: 'valencia-trinidad', population: 4500 }
    ]
  },
  // Barbados (Fase 12)
  {
    name: 'Barbados',
    slug: 'barbados',
    code: 'BB',
    population: 287375,
    topCities: [
      { name: 'Bridgetown', slug: 'bridgetown', population: 96578 },
      { name: 'Speightstown', slug: 'speightstown', population: 3634 },
      { name: 'Oistins', slug: 'oistins', population: 2285 },
      { name: 'Holetown', slug: 'holetown', population: 1350 },
      { name: 'Bathsheba', slug: 'bathsheba', population: 1200 },
      { name: 'Six Cross Roads', slug: 'six-cross-roads', population: 3500 },
      { name: 'Blackmans', slug: 'blackmans', population: 2100 },
      { name: 'Crab Hill', slug: 'crab-hill', population: 1800 },
      { name: 'The Crane', slug: 'the-crane', population: 950 },
      { name: 'Prospect', slug: 'prospect', population: 4200 },
      { name: 'Warrens', slug: 'warrens', population: 5800 },
      { name: 'Welches', slug: 'welches', population: 3200 },
      { name: 'Christ Church', slug: 'christ-church', population: 62000 },
      { name: 'St. Michael', slug: 'st-michael', population: 104000 },
      { name: 'St. James', slug: 'st-james-barbados', population: 26000 },
      { name: 'St. Peter', slug: 'st-peter', population: 11000 },
      { name: 'St. Lucy', slug: 'st-lucy', population: 9500 },
      { name: 'St. Andrew', slug: 'st-andrew', population: 6000 },
      { name: 'St. Joseph', slug: 'st-joseph', population: 7200 },
      { name: 'St. John', slug: 'st-john', population: 9000 },
      { name: 'St. Thomas', slug: 'st-thomas', population: 13500 },
      { name: 'St. George', slug: 'st-george', population: 19000 },
      { name: 'St. Philip', slug: 'st-philip', population: 20500 }
    ]
  },
  // Bahamas (Fase 12)
  {
    name: 'Bahamas',
    slug: 'bahamas',
    code: 'BS',
    population: 393244,
    topCities: [
      { name: 'Nassau', slug: 'nassau', population: 274400 },
      { name: 'Lucaya', slug: 'lucaya', population: 46525 },
      { name: 'Freeport', slug: 'freeport', population: 26910 },
      { name: 'West End', slug: 'west-end', population: 12724 },
      { name: 'Cooper\'s Town', slug: 'coopers-town', population: 8413 },
      { name: 'Marsh Harbour', slug: 'marsh-harbour', population: 5314 },
      { name: 'Freetown', slug: 'freetown-bahamas', population: 4342 },
      { name: 'High Rock', slug: 'high-rock', population: 3744 },
      { name: 'Andros Town', slug: 'andros-town', population: 2329 },
      { name: 'Clarence Town', slug: 'clarence-town', population: 86 },
      { name: 'Dunmore Town', slug: 'dunmore-town', population: 503 },
      { name: 'George Town', slug: 'george-town-bahamas', population: 1437 },
      { name: 'Rock Sound', slug: 'rock-sound', population: 890 },
      { name: 'Alice Town', slug: 'alice-town', population: 347 },
      { name: 'Nicholls Town', slug: 'nicholls-town', population: 631 },
      { name: 'Cockburn Town', slug: 'cockburn-town', population: 422 },
      { name: 'Settlement Point', slug: 'settlement-point', population: 1285 },
      { name: 'Spanish Wells', slug: 'spanish-wells', population: 1551 },
      { name: 'Harbour Island', slug: 'harbour-island', population: 1762 },
      { name: 'Governor\'s Harbour', slug: 'governors-harbour', population: 1671 }
    ]
  }
];
